type BillingCycle = 'annual' | 'monthly';
type Theme = 'light' | 'dark';
type PspContentType = 'reverseTrial';
type EntitlementTransitionFlowRemoveMargin = 'true' | 'false';

export type Offering = 'free' | 'standard' | 'premium';

export type Action = 'startTrial' | 'directBuy' | 'addPayment';

// type guards
export function isOffering(value: string): value is Offering {
	return ['free', 'standard', 'premium'].includes(value);
}

export function isAction(value: Action): value is Action {
	return ['startTrial', 'directBuy', 'addPayment'].includes(value);
}

export function isOfferingAction(value: unknown): value is OfferingAction {
	if (!value || typeof value !== 'object') {
		return false;
	}

	// Must have at least one valid key value pair
	return Object.entries(value).some((item) => {
		const offering = item[0];
		const action = item[1];
		return isOffering(offering) && isAction(action);
	});
}

type BaseConfigurationOptions = {
	[key: string]: string | string[] | OfferingAction | undefined;
};

export type OfferingAction = Record<Offering, Action>;

export type EntitlementTransitionOptions = {
	billingCycle?: BillingCycle;
	entitlementTransitionFlowRemoveMargin?: EntitlementTransitionFlowRemoveMargin;
	name: 'entitlementTransition';
	offeringHighlighted?: Offering;
	offeringsShown?: Offering[];
	offeringsWithActions?: OfferingAction;
	pspContentType?: PspContentType;
	showProgressNav?: string; // 'true' | 'false'
	theme?: Theme;
} & BaseConfigurationOptions;

export type ConfigurationOptions = EntitlementTransitionOptions | BaseConfigurationOptions;

type CompletedEntitlementTransition = {
	name: 'entitlementTransition';
};

type CompletedAddBillingAdmin = {
	name: 'addBillingAdmin';
};

type CompletedGeneric = {
	name: string;
};

type CompletedData = CompletedEntitlementTransition | CompletedAddBillingAdmin | CompletedGeneric;
type MessageData = Record<string, string>;

export type OnCompleteCallback = (data: CompletedData) => void;
export type OnErrorCallback = (error: Error) => void;
export type OnMessageCallback = (message: MessageData) => void;

declare global {
	interface Window {
		cexp_sdk?: {
			onComplete: OnCompleteCallback;
			onError: OnErrorCallback;
			onMessage?: OnMessageCallback;
		};
		cexp_sdk_development?: boolean;
	}
}
